module.exports = __webpack_public_path__ + "static/media/sun-her-flowers.dcb7a8f6.jpg";